import React from "react";
import Card from "../../../../../components/shared/Card/Card";
import { clamp100 } from "../../../../../utils/clamp100";

const BG_BY_TONE = {
  green: "success25",
  orange: "warning25",
  red: "error25",
};

const TEXT_BY_TONE = {
  green: "text-success700",
  orange: "text-warning700",
  red: "text-error700",
};

const TRANSITION_ORDER = [
  "PlvTrnSpdOrder",
  "ChstTrnSpdOrder",
  "LUArmSwngSpdOrder",
  "ShftSwngSpdOrder",
];

const MOVEMENT_ORDER = [
  "PlvSwyTranOrder",
  "PlvTrnTranOrder",
  "PlvLftTranOrder",
];

export const ReportIndicatorCardSequencing = ({
  indicatorName,
  indicatorsArray,
  percentage,
  valueToBaseColorOn,
}) => {
  const tone = valueToBaseColorOn === 100 ? "green" : "orange";
  const pct = clamp100(percentage);
  const nameIsShort = indicatorName.length < 20;

  const isTransition = indicatorName === "Transition Order";
  const filterIds = isTransition ? TRANSITION_ORDER : MOVEMENT_ORDER;

  const items = indicatorsArray
    .filter((el) => filterIds.includes(el.indicatorId))
    .sort((a, b) => a.value - b.value);

  return (
    <Card
      borderColor="gray200"
      className="flex flex-none w-[calc((100%-1.25rem)/3)] flex-col items-center p-1.5"
      color={BG_BY_TONE[tone]}
      rounded="md"
    >
      {/* Score */}
      <div className="mb-1 text-[10px] text-black">
        {pct.toFixed(0)}
        <span className="text-grayTrue500">/100</span>
      </div>

      {/* Title */}
      <div
        className={[
          "mb-1 text-center leading-3 font-bold text-black",
          nameIsShort ? "text-[10px]" : "text-[9px]",
        ].join(" ")}
      >
        {indicatorName}
      </div>

      {/* Ordered values */}
      <div
        className={[
          "grid auto-cols-fr grid-flow-col gap-0.5",
          TEXT_BY_TONE[tone],
        ].join(" ")}
      >
        {items.map((el) => (
          <div
            className="flex flex-col items-center gap-1 text-center"
            key={el.indicatorId}
          >
            <div className="text-sm font-bold">{el.value}</div>
            <div className="text-[10px] font-bold">
              {isTransition ? el.name.split(" ")[0] : el.name.split(" ")[1]}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
